import { Component, Input, OnInit } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';

@Component({
  selector: 'app-readmore-description',
  templateUrl: './readmore-description.component.html',
  styleUrls: ['./readmore-description.component.scss'],
})
export class ReadmoreDescriptionComponent implements OnInit {
  @Input() description: string;
  @Input() descriptionTitle: string;

  readMoreText = false;

  constructor() {}

  ngOnInit() {}

  readMore(): void {
    this.readMoreText = !this.readMoreText;
  }
}
